export default __webpack_public_path__ + "static/media/calendar-clock.b974216f.svg";